export function AccessCodeIcon() {
  return (
    <svg
      width="222"
      height="222"
      viewBox="0 0 222 222"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="28"
        y="28"
        width="166"
        height="166"
        rx="83"
        fill="url(#paint0_radial_8595_6185)"
        fillOpacity="0.34"
      />
      <path
        d="M108 109.5L110.5 73.5L112 109.5H108Z"
        fill="#DED287"
        stroke="#DED287"
      />
      <path
        d="M110 108L171 110.5L110 112L110 108Z"
        fill="#DED287"
        stroke="#DED287"
      />
      <circle
        cx="110"
        cy="110"
        r="4"
        fill="#4F4F4F"
        stroke="#A1A1A1"
        strokeWidth="2"
      />
      <rect
        x="29"
        y="29"
        width="164"
        height="164"
        rx="82"
        stroke="url(#paint1_linear_8595_6185)"
        strokeWidth="2"
      />
      <path
        d="M183 111C183 71.2355 150.765 39 111 39"
        stroke="url(#paint2_linear_8595_6185)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_8595_6185"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-66.4 126.941 -126.941 -80.7742 172.973 -4.34558)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#10100F" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_8595_6185"
          x1="151.505"
          y1="111"
          x2="117.438"
          y2="179.181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A1A1" />
          <stop offset="1" stopColor="#10100F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8595_6185"
          x1="155"
          y1="64.5"
          x2="184.073"
          y2="107.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A1A1" />
          <stop offset="1" stopColor="#10100F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
